import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { IModalNavigator } from '../../../../component-lib/components/modal/navigator/modal-navigator.interface';
import { IMultiModalComponent } from '../../../../component-lib/components/modal/navigator/multi-modal-component.interface';
import { SlideCardInterface } from '../../../../component-lib/components/slide-card/slide-card.interface';
import { ChargingCardInputComponent } from '../../charging-card-input/charging-card-input.component';
import { ChargingCardOutboundFormComponent } from '../form/form.component';

@Component({
  templateUrl: './info.component.html',
})
export class ChargingCardOutboundInfoComponent implements OnInit, IMultiModalComponent {
  public model: SlideCardInterface;
  public modalNavigator: IModalNavigator;
  public canGoBack = true;

  constructor(private translateService: TranslateService, private analyticsService: AnalyticsService) {
    this.model = {
      src: `./assets/evsb/img/charging-card/outbound-info.svg`,
      title: this.translateService.instant('modules.evsb.chargingCard.outbound.info.title'),
      text: this.translateService.instant('modules.evsb.chargingCard.outbound.info.text'),
    };
  }

  ngOnInit(): void {
    this.analytics();
  }

  public navigateToForm() {
    this.analyticsForm();
    const modalInstance = this.modalNavigator.goToView(
      ChargingCardOutboundFormComponent
    ) as ChargingCardOutboundFormComponent;
  }

  public goBack(): void {
    this.analyticsGoBack();
    const modalInstance = this.modalNavigator.goToView(ChargingCardInputComponent) as ChargingCardInputComponent;
  }

  private analytics(): void {
    this.analyticsService.push({
      event: 'b-to-b-ev-simulator-flow',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'step-charging-card',
      eventLabel: 'outbound-charging-card',
    });
  }

  private analyticsForm(): void {
    this.analyticsService.push({
      event: 'cta',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'click-cta-outbound-charging-card',
      eventLabel: 'form-open',
    });
  }

  private analyticsGoBack(): void {
    this.analyticsService.push({
      event: 'cta',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'click-cta-outbound-charging-card',
      eventLabel: 'select-less-card',
    });
  }
}
